/**
 * North American craft malthouses (the United States, Canada and Mexico),
 * assembled from the per-region files.
 *
 * Order is region-by-region rather than alphabetical: the files are the unit
 * of maintenance, and a stable order makes diffs readable.
 */

import type { Fermentable } from '../../../schema/fermentable';
import { canadaCraftFermentables } from './canada';
import { mexicoCraftFermentables } from './mexico';
import { midwestCraftFermentables } from './midwest';
import { mountainWestCraftFermentables } from './mountain-west';
import { northeastCraftFermentables } from './northeast';
import { southeastCraftFermentables } from './southeast';
import { westCoastCraftFermentables } from './west-coast';

export { canadaCraftFermentables } from './canada';
export { mexicoCraftFermentables } from './mexico';
export { midwestCraftFermentables } from './midwest';
export { mountainWestCraftFermentables } from './mountain-west';
export { northeastCraftFermentables } from './northeast';
export { southeastCraftFermentables } from './southeast';
export { westCoastCraftFermentables } from './west-coast';

/** Every North American craft-malthouse fermentable in the catalog. */
export const craftMalthouseFermentables: readonly Fermentable[] = [
  ...northeastCraftFermentables,
  ...southeastCraftFermentables,
  ...midwestCraftFermentables,
  ...mountainWestCraftFermentables,
  ...westCoastCraftFermentables,
  ...canadaCraftFermentables,
  ...mexicoCraftFermentables,
];
